import ky from 'ky'
import type { Options } from 'ky'
import type { GetPresignResponse } from '@/types/presign'
import { httpClient } from '@/utils/http'

export const presignService = {
  getPresignUrl: (options?: Options) =>
    httpClient.get('presign', options).json<GetPresignResponse>(),
  uploadWithPresign: async (presign: GetPresignResponse, file: File) => {
    const { url, fields, headers, method } = presign

    const formData = new FormData()
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v))
    formData.append('file', file)

    await ky(url, {
      method,
      headers,
      body: formData,
    })

    return {
      id: fields.key.split('/').pop(),
      file,
      fields,
      previewUrl: URL.createObjectURL(file),
    }
  },
  uploads: async (files: FileList | Array<File>) => {
    const resPresigns = await Promise.allSettled(
      Array.from(files).map(async (file) => {
        const presign = await presignService.getPresignUrl({
          searchParams: { filename: file.name },
        })
        return { file, presign }
      }),
    )
    const shouldUploads = resPresigns.filter(
      (res) => res.status === 'fulfilled',
    ) as Array<
      PromiseFulfilledResult<{
        file: File
        presign: GetPresignResponse
      }>
    >

    if (!shouldUploads.length) return []

    const resUploads = await Promise.allSettled(
      shouldUploads.map((upload) =>
        presignService.uploadWithPresign(
          upload.value.presign,
          upload.value.file,
        ),
      ),
    )
    const uploads = resUploads.filter((res) => res.status === 'fulfilled')

    if (!uploads.length) return []

    return uploads.map((upload) => upload.value)
  },
}
